export type UserData = {
    loggedIn: boolean
    name: string
    email: string
    org: string
    company: string
    country: string
    limitedAccess: boolean
    localAccountId: string
    featureFlagEnabled: boolean,
    allRoles: string[],
    actualRoles: string[],
    currentRole: string
    expiry: number
    expiryStr: string
    lastName: string
    firstName: string
    companyId: string
    empType: string
    contactNumber: string
}

export const emptyUserData: UserData = {
    loggedIn: false,
    email: "",
    name: "",
    org: "",
    company: "",
    country: "",
    localAccountId: "",
    limitedAccess: true,
    featureFlagEnabled: false,
    allRoles: [],
    actualRoles: [],
    currentRole: "",
    expiry: 0,
    expiryStr: "",
    lastName: "",
    firstName: "",
    companyId: "",
    empType: "",
    contactNumber: "",
};



